import setLocation from './setLocation';

export default setLocation;
